import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchShipperprof(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.id;
  let url;
  if (user.role === "shipper-enterprise") {
    url = `${appConfig.ip}/shipperProf/${id}`;
  } else if(user.role === "shipper-individual") {
    url = `${appConfig.ip}/shipperProf/${id}`;
  }else {
    url = `${appConfig.ip}/licenseeProf/${id}`;
  }

  try {
    // const res = yield fetch(`${appConfig.ip}/shipperProf/`+id, {
    //   method: "GET",
    //   headers: {
    //     Accept: "application/json",
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer ${token}`,
    //   },
    // });
    const res = yield fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
     
      yield put({
        type: actionTypes.FETCH_SHIPPERPROF_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SHIPPERPROF_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* updateProfileImage(value){
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.id;


  try {
    const data = new FormData();

    data.append(id, value.value, value.value.name);

    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/users/image`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });
    if (!res.ok) {
      throw res;
    } else { 
      const resJSON = yield res.json();
      console.log(resJSON);

      localStorage.setItem(
        "user",
        JSON.stringify({
          ...user,
          picture: resJSON.picture,
        })
      );

      //window.location.reload()
      yield put({
        type:actionTypes.FETCH_SHIPPERPROF_ACTION
      })
      yield put(push("/myprofile"));
      yield put({
        type: actionTypes.UPDATE_PROF_IMAGE_SUCCESS,
        payload: resJSON,
      });

      yield toast.success("Profile image updated successfully", {
        autoClose: 3000,
        className: "toastClass",
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.UPDATE_PROF_IMAGE_FAIL,
        error: err,
      });
    } else {
    }
  }


}

export function* ShipperProfActionWatcher() {
  yield takeEvery(actionTypes.FETCH_SHIPPERPROF_ACTION, fetchShipperprof);
  yield takeEvery(actionTypes.UPDATE_PROF_IMAGE_INIT, updateProfileImage);
}
